/**
 * Redirects to a URL, without saving the URL in the history
 * Takes care of adding the context automatically
 *
 * @param {string} redirectUrl without the context
 */
export const redirectTo = (redirectUrl) => {
    location.replace(`${window.location.origin}${redirectUrl}`);
};
/**
 * Redirects to the login page if the user is not authenticated (dealt in the BE)
 */
export const redirectToLoginPage = () => {
    // TODO: Remove context when PLAT-2810 is implemented
    const context = location.pathname.split('/')[1];
    redirectTo(`/${context}/main`);
};
export const redirectToHomePage = () => {
    // TODO: Remove context when PLAT-2810 is implemented
    const context = location.pathname.split('/')[1];
    redirectTo(`/${context}/main/home`);
};
